import * as React from 'react'
import { Link } from 'react-router-dom'

import * as styles from './breadcrumb.module.css'

const Separator = () => <span className={styles.separator}>/</span>

export interface IMenu {
  name: string
  path?: string
}

interface IProps {
  menus: IMenu[]
}

const BreadCrumbs = ({ menus }: IProps) => {
  const links = menus.map((link, index) => {
    const isLastElement = index === menus.length - 1
    return (
      <React.Fragment key={index}>
        <li
          property="itemListElement"
          typeof="ListItem"
          className={styles.list}
        >
          {isLastElement ? (
            <span className="name" property="name">
              {link.name}
            </span>
          ) : (
            <Link to={link.path || '#'} className={styles.link}>
              <span className="name" property="name">
                {link.name}
              </span>
            </Link>
          )}
          <meta property="position" content={(index + 1).toString()} />
        </li>
        {index < menus.length - 1 && <Separator />}
      </React.Fragment>
    )
  })
  return (
    <ol
      className={styles.root}
      vocab="http://schema.org/"
      typeof="BreadcrumbList"
    >
      {links}
    </ol>
  )
}

export default BreadCrumbs
